import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Paper, FormControl, Button, TextField,
} from '@material-ui/core';

import Actions from '../actions';

class SearchUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: '',
    };
  }

    handleChange = (e) => {
      this.setState({ user: e.target.value });
    }

    onSubmit = (e) => {
      e.preventDefault();
      this.props.fetchUser(this.state.user)
        .then(() => {
          const { user } = this.props;
          if (user) this.props.userSelected();
          else alert('User not found!');
        });
    }

    render() {
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Paper style={{ width: '500px', padding: '50px' }}>
            <h3 style={{ marginTop: 0 }}>Search User</h3>
            <form onSubmit={(e) => { return this.onSubmit(e); }}>
              <FormControl fullWidth>
                <TextField name="user" label="Email or Phone or UID or Name" value={this.state.user} onChange={(e) => { this.handleChange(e); }} />
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '20px' }}>
                <Button variant="contained" type="submit" color="primary">Search User</Button>
              </FormControl>
            </form>
          </Paper>
        </div>
      );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    user: state.user.data,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchUserForm);
